import React from 'react';
import usePageTitle from '../hooks/usePageTitle';
import { CalendarDaysIcon } from '@heroicons/react/24/outline';

const MonthlyStatistics = () => {
  usePageTitle('Monthly Statistics');

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Monthly Statistics</h1>
          <p className="page-subtitle">Monthly performance metrics and trends</p>
        </div>
      </div>

      <div className="card">
        <div className="empty-state">
          <CalendarDaysIcon className="empty-state-icon" />
          <p className="empty-state-title">Coming soon</p>
          <p>Monthly statistics functionality will be available here.</p>
        </div>
      </div>
    </div>
  );
};

export default MonthlyStatistics;
